import { useEffect } from 'react'

export const useOutsideClick = (
  ref: any,
  onClickOutside: () => void,
  deps: any[]
) => {
  useEffect(() => {
    const onClick = ({ target }: any) =>
      !ref?.contains(target) && onClickOutside?.()
    document.addEventListener('click', onClick)
    return () => {
      document.removeEventListener('click', onClick)
    }
  }, deps)
}
